<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">{{'BUTTON.VIEW' | translate}} {{"COMMON.DETAIL" | translate}}</h5>
      <div class="edit-icons" mat-dialog-close>
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content">
        <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
        <div style="overflow-x:auto;overflow-y: auto;" class="mt-3 mt-lg-5 table-box" *ngIf="!isSpinnerLoading">
          <table class="mt-4" mat-table [dataSource]="dataSource"  *ngIf="viewType=='employee' && dataSource.data.length!=0"
             class="mat-elevation-z8">
            <ng-container matColumnDef="user_info">
              <th mat-header-cell *matHeaderCellDef > {{"COMMON.USERINFO" | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="profile-img me-2" [appBackgroundImg]="element.employee_img">

                  </div>
                  <div class="">
                    <div>{{element.employee_name }} {{element.employee_name1}}</div>
                    <div class="steel-blue">{{element.employee_email}}</div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="course_info">
              <th mat-header-cell *matHeaderCellDef  >
               {{"COURSE.INFO"|translate}}
              </th>
              <td mat-cell *matCellDef="let element" style="min-width:200px">
                <div class="d-flex align-items-center">
                  <div class="profile-img me-2" [appBackgroundImg]="element.img" iType="course"> </div>
                  <div class=""> {{element.tit }}</div>
                </div>
              </td>
            </ng-container>           
            <ng-container matColumnDef="training_date">
              <th mat-header-cell *matHeaderCellDef >    {{"COURSE.TDATE"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.tr_dt| dates}} </td>
            </ng-container>
            <ng-container matColumnDef="deadline_date">
              <th mat-header-cell *matHeaderCellDef >{{"COURSE.DDATE"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.de_dt | dates}} </td>
            </ng-container>
            <ng-container matColumnDef="course_type">
              <th mat-header-cell *matHeaderCellDef >{{"COURSE.TYPE"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-bold st-box  d-flex ">
                  <span class="blue-badge badge-c d-box" *ngIf="element.is_info== 1">{{"COURSE.EXAM"|translate}}</span>
                  <span class="active badge-c d-box" *ngIf="element.is_info == 0">{{"COURSE.INFORMATIONAL"|translate}}</span>
               </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="start_course">
              <th mat-header-cell *matHeaderCellDef > {{"COURSE.STATUS"|translate}}</th>
              <td mat-cell *matCellDef="let element"> 
                <div class="text-bold st-box  d-flex ">
                  <span class="pending badge-c d-box"   *ngIf="element.is_st && !(element.per >= 100)">{{"STATUS.ACTIVE" | translate}}</span>
                  <span class="un-attend badge-c d-box"  *ngIf="!element.is_st">{{"STATUS.UNATTENDED" | translate}}</span>
                  <span class=" active  badge-c d-box" *ngIf="element.is_st && element.per >= 100">{{"STATUS.COMPLETED" | translate}}</span>
               </div> 
              </td>
            </ng-container>
            <ng-container matColumnDef="course_progres">
              <th mat-header-cell *matHeaderCellDef>{{"COURSE.PROGRESS"|translate}}</th>
              <td mat-cell *matCellDef="let element" class="percentage-box">
                <mat-progress-bar mode="determinate" class="progress-m progress-round green-progress progress-shadow"
                  [value]="element.per"></mat-progress-bar>
                <div class="text-center per-b">{{element.per}}% </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>{{"COMMON.ACTION"|translate}}</th>
              <td mat-cell *matCellDef="let element" >
                <div class="d-flex align-items-center  ">
                  <div class="action-icon  me-2" (click)="onViewExamSheet(element)"  *ngIf="element.is_att">
                    <img src="assets/images/icons/view_icon.png" class="img-fluid" alt="">
                  </div>         
                  <div class="action-icon me-2" *ngIf="element.c_img" (click)="onCertificateDownload(element)">
                    <img src="assets/images/icons/certificate_ic.svg" class="img-fluid">
                  </div> 
                  <div class="action-icon me-2" (click)="onMoreInfo(element)">
                    <img src="assets/images/icons/more_info.svg" class="img-fluid">
                  </div>                       
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsEmp"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsEmp;"></tr>
          </table>
          <table class="mt-4" mat-table [dataSource]="dataSource"  *ngIf="viewType=='department_assigned' && dataSource.data.length!=0"
             class="mat-elevation-z8">
            <ng-container matColumnDef="user_info">
              <th mat-header-cell *matHeaderCellDef  >Name
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="profile-img me-2" [appBackgroundImg]="element.img" [iType]="convertToLowerCase(element.group_type)">
     
                  </div>
                  <div class="">
                    <div>{{element.f_n }} {{element.l_n}}</div>
                    <div class="steel-blue">{{element.el}}</div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef > User Type</th>
              <td mat-cell *matCellDef="let element"> {{element.group_type}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="mat-table__message" *ngIf="dataSource.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>
    </div>
    <div class="d-flex justify-content-between align-items-center flex-wrap" *ngIf="dataSource.data.length!=0">
      <div class="me-3 text-grey d-flex align-items-center">
        {{"COMMON.SIP" | translate}}
        <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
          <option [value]="item" *ngFor="let item of pageSizeOptions"> {{ item }}</option>
        </select>
      </div>
      <div>
        <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
          [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
      </div>
    </div>
  </div>
  <app-loading-spinner></app-loading-spinner>